// Chrome = AnnounceBar + Header + Footer + CartDrawer scrim/toast (โครงจาก prototype)
import { useState } from 'react';
import { CONFIG, CATS } from '../data/catalog.js';
import { fmt } from '../lib/money.js';
import { useStore } from '../lib/store.jsx';
import { useI18n } from '../lib/i18n.jsx';
import CartDrawer from './CartDrawer.jsx';
import SearchOverlay from './SearchOverlay.jsx';

export function AnnounceBar() {
  const { t } = useI18n();
  return (
    <div className="announce">
      <b>BAREBONES THAILAND</b> · {t('banner.free', fmt(CONFIG.freeShipThreshold))}
    </div>
  );
}

export function Header({ nav }) {
  const { cartQty, setDrawerOpen, setSearchOpen } = useStore();
  const { lang, setLang } = useI18n();
  const [mobileNav, setMobileNav] = useState(false);
  const go = (path) => { setMobileNav(false); nav(path); };
  return (
    <header>
      <div className="wrap hbar">
        <button className="iconbtn menutgl" onClick={() => setMobileNav(!mobileNav)} aria-label="เมนู">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
        </button>
        <a href="/" onClick={(e) => { e.preventDefault(); go('/'); }} className="brand" aria-label="Barebones">
          <img className="brand-logo" src="/barebones-logo.svg" alt="Barebones" width="137" height="26" />
          <small>Beautiful · Durable · Essential</small>
        </a>
        <nav className={`main${mobileNav ? ' mobile-open' : ''}`}>
          <a href="/c/power-light" onClick={(e) => { e.preventDefault(); go('/c/power-light'); }}>Power &amp; Light</a>
          <a href="/c/tools" onClick={(e) => { e.preventDefault(); go('/c/tools'); }}>Tools</a>
          <a href="/c/cook-dine" onClick={(e) => { e.preventDefault(); go('/c/cook-dine'); }}>Cook &amp; Dine</a>
          <a href="/c/store-carry" onClick={(e) => { e.preventDefault(); go('/c/store-carry'); }}>Store &amp; Carry</a>
          <a href="/c/all" onClick={(e) => { e.preventDefault(); go('/c/all'); }}>Shop All</a>
          <a href="/track" onClick={(e) => { e.preventDefault(); go('/track'); }}>Track Order</a>
        </nav>
        <div className="spacer" />
        <div className="icons">
          <button className="iconbtn langtgl" onClick={() => setLang(lang === 'en' ? 'th' : 'en')}
            aria-label={lang === 'en' ? 'เปลี่ยนเป็นภาษาไทย' : 'Switch to English'}>
            {lang === 'en' ? 'ไทย' : 'EN'}
          </button>
          <button className="iconbtn" onClick={() => setSearchOpen(true)} aria-label="ค้นหา">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
          </button>
          <button className="iconbtn" style={{ position: 'relative' }} onClick={() => setDrawerOpen(true)} aria-label="ตะกร้า">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M6 7h12l-1 13H7L6 7Z" /><path d="M9 7a3 3 0 0 1 6 0" /></svg>
            {cartQty > 0 && <span className="cartcount">{cartQty}</span>}
          </button>
        </div>
      </div>
    </header>
  );
}

export function Footer({ nav }) {
  const { t } = useI18n();
  const link = (path, label) => (
    <a href={path} onClick={(e) => { e.preventDefault(); nav(path); }}>{label}</a>
  );
  return (
    <footer>
      <div className="wrap">
        <div className="cols">
          <div>
            <div className="brand"><img className="brand-logo footer-logo" src="/barebones-logo.svg" alt="Barebones" width="127" height="24" /><small style={{ letterSpacing: '.34em' }}>THAILAND</small></div>
            <p className="blb">{t('footer.blurb')}</p>
          </div>
          <div><h5>{t('footer.shop')}</h5><ul>
            <li>{link('/c/power-light', 'Power & Light')}</li>
            <li>{link('/c/tools', 'Tools')}</li>
            <li>{link('/c/cook-dine', 'Cook & Dine')}</li>
            <li>{link('/c/store-carry', 'Store & Carry')}</li>
            <li>{link('/c/all', t('footer.all'))}</li>
          </ul></div>
          <div><h5>{t('footer.help')}</h5><ul>
            <li>{link('/track', t('footer.track'))}</li>
            <li>{link('/help/shipping-returns', t('footer.shipret'))}</li>
            <li>{link('/help/payment', t('footer.payment'))}</li>
            <li>{link('/help/how-to-order', t('footer.howto'))}</li>
            <li>{link('/help/faq', t('footer.faq'))}</li>
          </ul></div>
          <div><h5>{t('footer.contact')}</h5><ul>
            <li className="mono" style={{ fontSize: 12 }}><a href={`mailto:${CONFIG.email}`}>{CONFIG.email}</a></li>
            <li className="mono" style={{ fontSize: 12 }}>{CONFIG.domain}</li>
            <li>
              <a href="https://www.facebook.com/barebones.th/" target="_blank" rel="noopener noreferrer">Facebook</a>
              {' · '}
              <a href="https://www.instagram.com/barebones_thailand" target="_blank" rel="noopener noreferrer">Instagram</a>
            </li>
          </ul></div>
        </div>
        <div className="base">
          <span>© 2026 BAREBONES THAILAND · CAMP STUDIO (THAILAND) CO., LTD. · SOLE DISTRIBUTOR</span>
          <span>BEAUTIFUL. DURABLE. ESSENTIAL.</span>
        </div>
      </div>
    </footer>
  );
}

export function Overlays({ nav }) {
  const { drawerOpen, setDrawerOpen, toast } = useStore();
  return (
    <>
      <div className={`scrim${drawerOpen ? ' show' : ''}`} onClick={() => setDrawerOpen(false)} />
      <CartDrawer nav={nav} />
      <SearchOverlay nav={nav} />
      <div className={`toast${toast ? ' show' : ''}`}>{toast}</div>
    </>
  );
}
